import { lazy } from 'react';

const ApplicationSubmittedModal = lazy(
  () => import('./modals/ApplicationSubmittedModal'),
);

const BYOPApplicationSubmittedModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramExploration/modals/BYOPApplicationSubmittedModal'
    ),
);

const BYOPEditApplicationModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramExploration/modals/BYOPEditApplicationModal'
    ),
);

const CandidateProfileModal = lazy(
  () => import('./modals/CandidateProfileModal'),
);

const CreateAccountModal = lazy(() => import('./modals/CreateAccountModal'));

const LoginFromMagicLinkModal = lazy(
  () => import('./modals/LoginFromMagicLinkModal'),
);

const OpportunityDetailsModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramExploration/modals/OpportunityDetailsModal'
    ),
);

const ProgramDetailsModal = lazy(() => import('./modals/ProgramDetailsModal'));

const SurveyModal = lazy(() => import('./modals/SurveyModal'));

export default {
  APPLICATION_SUBMITTED_MODAL: ApplicationSubmittedModal,
  BYOP_APPLICATION_SUBMITTED_MODAL: BYOPApplicationSubmittedModal,
  BYOP_EDIT_APPLICATION_MODAL: BYOPEditApplicationModal,
  CANDIDATE_PROFILE_MODAL: CandidateProfileModal,
  CREATE_ACCOUNT_MODAL_PROGRAMS: CreateAccountModal,
  LOGIN_FROM_MAGIC_LINK_MODAL: LoginFromMagicLinkModal,
  OPPORTUNITY_DETAILS_MODAL: OpportunityDetailsModal,
  PROGRAM_DETAILS_MODAL: ProgramDetailsModal,
  SURVEY_MODAL: SurveyModal,
};
